import { Icon } from './icon';
import './uploadImageAndCrop.scss';
import { showMsgToast } from './util';
import { lang } from '@umu/ukit-lang';
import { ITabPane, Tabs } from './tabs';
import { classSet } from '@umu/umu-dom';
import CheckIcon from './images/CheckIcon.png';
import { Modal, Button } from '@umu/umu-design';
import { ImgCropPortal } from '../imgCropPortal';
import * as imageUtil from '@umu/umu-image-handle';
import { FormLabel } from '../formLabel/formLabel';
import AddWhiteIcon from './images/AddWhiteIcon.png';
import { FILE_MAX_SIZE, tabParams } from './dataflow';
import React, { Fragment, useRef, useState } from 'react';
import { IMG_FILE_ACCEPTS } from '../navigationContextModal/dataFlow';

import {
    IImgCardProps,
    IMG_UPLOAD_TYPE,
    IRecommendImgInfo,
    IUploadFileProps,
    ImgSourceProps,
    RenderUploadImageAndCropDialogProps,
    SOURCE_IMG_TYPE,
} from './interface';
import { isHarmonyOS } from '@umu/umu-ua';

const { confirm } = Modal;

export const UploadFile = (props: IUploadFileProps) => {
    const { children, accept = '', onChooseFile, multiple = false } = props;
    const inputRef = useRef<HTMLInputElement>(null);
    const uploadFile = () => {
        if (inputRef.current) {
            inputRef.current.click();
        }
    };

    const isHarmony = isHarmonyOS();

    return (
        <Fragment>
            <input
                type="file"
                name="fileImg"
                title=""
                ref={inputRef}
                accept={accept}
                style={{ display: 'none' }}
                onChange={onChooseFile}
                multiple={isHarmony ? false : multiple}
            />
            <div className="file-uploads" onClick={uploadFile}>
                {children}
            </div>
        </Fragment>
    );
};

export const ImgCardList = (props: IImgCardProps) => {
    const { list, label, onChange, selectData, type, className = '' } = props;
    const renderContent = () => {
        return list.map((_) => {
            return (
                <div
                    key={`banner-${_.id}-${type}-img`}
                    onClick={() => onChange({ ..._, id: `${type}-${_.id}` })}
                    className={classSet({
                        'banner-item': true,
                        'banner-item-select': `${type}-${_.id}` === selectData.id,
                    })}
                >
                    <Icon imgSrc={imageUtil.appendWidth(_.thumb || _.url, 210)} className="icon-banner-img" />
                    {`${type}-${_.id}` === selectData.id && (
                        <Icon imgSrc={imageUtil.appendWidth(CheckIcon, 18)} className="icon-banner-img-select" />
                    )}
                </div>
            );
        });
    };
    return (
        <FormLabel label={label}>
            <div className={`banner-img-list ${className}`}>{renderContent()}</div>
        </FormLabel>
    );
};

export const ImgSource = (props: ImgSourceProps) => {
    const { imgSrc = '', onClose, multiple = 1, isShowToolBar = true } = props;
    const [tabIndex, setTabIndex] = useState<IMG_UPLOAD_TYPE>(IMG_UPLOAD_TYPE.UPLOAD_SELF);
    const [imgUrl, setImgUrl] = useState(imgSrc);
    const [sourceImgType, setSourceImgType] = useState<SOURCE_IMG_TYPE>(props.sourceImgType || SOURCE_IMG_TYPE.CUSTOM);
    const [selectData, setSelectData] = useState<IRecommendImgInfo>({
        id: '',
        url: '',
    });
    const onTabChange = (item: ITabPane) => {
        setTabIndex(item.key as IMG_UPLOAD_TYPE);
    };
    const renderTab = () => {
        const bannerList = (!props.isShowDefaultImg ? props.bannerList : props.defaultImgList) || [];
        const illustrationList = props.illustrationList || [];
        const isShowRecommendByUmu = !!bannerList.length || !!illustrationList.length;
        return (
            <Tabs
                params={isShowRecommendByUmu ? tabParams : [tabParams[0]]}
                activeKey={tabIndex}
                onChange={onTabChange}
            ></Tabs>
        );
    };
    const onImgSelect = (data: IRecommendImgInfo) => {
        setSelectData(data);
        setSourceImgType(!props.isShowDefaultImg ? SOURCE_IMG_TYPE.CUSTOM : SOURCE_IMG_TYPE.AVATAR);
    };
    const renderRecommendImg = () => {
        const bannerList = (!props.isShowDefaultImg ? props.bannerList : props.defaultImgList) || [];
        const illustrationList = props.illustrationList || [];
        return (
            (!!bannerList.length || !!illustrationList.length) && (
                <div className="img-banner-zone">
                    {!!bannerList.length && (
                        <ImgCardList
                            list={bannerList}
                            label={!props.isShowDefaultImg ? lang('UMU图片库') : ''}
                            onChange={onImgSelect}
                            selectData={selectData}
                            className={!props.isShowDefaultImg ? '' : 'show-default-img-list'}
                            type="banner"
                        />
                    )}
                    {!props.isShowDefaultImg && !!illustrationList.length && (
                        <ImgCardList
                            list={illustrationList}
                            label={lang('UMU插画库')}
                            type="illustration"
                            onChange={onImgSelect}
                            selectData={selectData}
                        />
                    )}
                </div>
            )
        );
    };
    const onChooseFile = (ev: React.ChangeEvent<HTMLInputElement>) => {
        const fileList = ev.target.files;
        if (!fileList || !fileList.length) {
            return;
        }
        const files = Array.from(fileList);
        if (files[0] && files[0].size > FILE_MAX_SIZE) {
            showMsgToast(lang('建议单张图片不超过10M'));
            return;
        }
        const preUrl = URL.createObjectURL(files[0]);
        setImgUrl(preUrl);
        setSourceImgType(SOURCE_IMG_TYPE.CUSTOM);
    };

    const renderContent = () => {
        return tabIndex === IMG_UPLOAD_TYPE.UPLOAD_SELF ? (
            <UploadFile onChooseFile={onChooseFile} accept={IMG_FILE_ACCEPTS}>
                <div className="upload-zone">
                    <div className="add-link-img">
                        <Icon imgSrc={AddWhiteIcon} className="icon-img-add" />
                        <div>{lang('选择一张图片上传')}</div>
                    </div>
                    <div className="info-msg">{lang('建议单张图片不超过10M')}</div>
                </div>
            </UploadFile>
        ) : (
            renderRecommendImg()
        );
    };
    const onSubmit = () => {
        if (tabIndex === IMG_UPLOAD_TYPE.RECOMMEND_BY_UMU) {
            setImgUrl(imageUtil.appendWidth(selectData.thumb || selectData.url));
        }
    };
    const renderFooter = () => {
        return !imgUrl ? (
            <div className="operate-footer">
                <Button type="ghost-grey" className="operate-footer-btn-split" onClick={onClose}>
                    {lang('取消')}
                </Button>
                <Button onClick={onSubmit} type="primary-blue">
                    {lang('确认')}
                </Button>
            </div>
        ) : null;
    };
    const onUploadError = () => {
        showMsgToast(lang('上传失败'));
    };
    const onReloadImg = () => {
        setImgUrl('');
    };

    return (
        <div className="image-source-panel custom-image-source-panel">
            {imgUrl ? (
                <ImgCropPortal
                    uploadLoadText={props.uploadLoadText || ''}
                    panelTitle={props.panelTitle}
                    src={imgUrl}
                    multiple={multiple}
                    isShowToolBar={isShowToolBar}
                    sourceImgType={sourceImgType}
                    cropRatio={props.cropRatio}
                    teacherId={props.userId}
                    onErr={onUploadError}
                    onChangeImg={onReloadImg}
                    onCancel={onClose}
                    onConfirm={props.onConfirm}
                />
            ) : (
                <div className="image-select-source">
                    {renderTab()}
                    {renderContent()}
                    {renderFooter()}
                </div>
            )}
        </div>
    );
};

export const onRenderUploadImageAndCropDialog = (data: RenderUploadImageAndCropDialogProps) => {
    const dialog = confirm({
        footer: null,
        centered: true,
        width: '7.74rem',
        title: data.title || '',
        closable: data.closable ?? false,
        wrapClassName: 'upload-image-and-crop-dialog',
        zIndex: data.zIndex,
        content: (
            <ImgSource
                imgSrc={data.urls}
                {...data}
                uploadLoadText={lang('图片生成中')}
                onClose={() => {
                    data?.onClose && data?.onClose();
                    dialog.destroy();
                }}
            />
        ),
    } as any);
    return dialog;
};
